<template>
	<v-container fluid>
		<PersonModal :companyid="company.id" :id="0" :show="personModalShow" @callback="personModalCallback"/>
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-tabs v-model="tabId">
				<v-tab>{{ $t('tabs.general') }}</v-tab>
				<v-tab v-if="company.id!=0 && company.subject_type_id==1">{{ $t('tabs.buyerTours') }}</v-tab>
				<v-tab v-if="company.id!=0 && company.subject_type_id==2">{{ $t('tabs.supplierTours') }}</v-tab>
				<v-tab v-if="company.id!=0">{{ $t('tabs.people') }}</v-tab>
				<v-tab-item>
					<v-layout row wrap>
						<v-flex lg8 md12 sm12 xl6 xs12>
							<v-card>
								<v-card-text>
									<v-layout row wrap>
										<v-flex md6 xs12>
											<v-layout row wrap>
												<v-flex xs12>
													<InputField :error="companyValidation.name"
																:label="'* '+$t('fields.name')"
																v-model="company.name"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="companyValidation.address"
																:label="'* '+$t('fields.address')"
																v-model="company.address"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="companyValidation.city"
																:label="'* '+$t('fields.city')"
																v-model="company.city"></InputField>
												</v-flex>
												<v-flex xs12>
													<Dropdown
														:ajax="true"
														:data="'countries'" :error="companyValidation.country_id"
														:label="'* '+$t('fields.country')"
														v-model="company.country_id"></Dropdown>
												</v-flex>
												<v-flex xs12>
													<InputField :error="companyValidation.oib"
																:label="$t('fields.oibVat')"
																v-model="company.oib"></InputField>
												</v-flex>
												<v-flex xs12>
													<CheckBox
														:label="$t('fields.active')"
														v-model="company.active"></CheckBox>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex md6 xs12>
											<v-layout row wrap>
												<v-flex xs12>
													<InputField :error="companyValidation.phone"
																:label="$t('fields.phone')"
																v-model="company.phone"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="companyValidation.email"
																:label="$t('fields.email')"
																v-model="company.email"></InputField>
												</v-flex>

												<v-flex xs12>
													<Dropdown
														:ajax="true"
														:data="'subject-types'"
														:error="companyValidation.subject_type_id"
														:label="'* '+$t('fields.type')"
														:readonly="company.linked"
														v-model="company.subject_type_id"></Dropdown>
												</v-flex>
												<v-flex xs12>
												<TextArea
													:error="companyValidation.notes"
													:label="$t('fields.notes')"
													v-model="company.notes"/>
												</v-flex>
												<v-flex xs12>
													<UploadMultiple :label="$t('fields.documents')"
																	v-model="company.documents"/>
												</v-flex>
												<v-flex v-if="company.id != 0" xs12>
													<DatePicker :dateLabel="$t('fields.dateAdded')" :readonly="true"
																v-model="company.date_added_display"/>
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
				<v-tab-item v-if="company.id!=0 && company.subject_type_id==1">
					<v-layout row wrap>
						<v-flex xs12>
							<v-card>
								<v-card-text>
									<v-layout row wrap>
										<v-spacer></v-spacer>
										<v-tooltip bottom>
											<v-btn @click="toggleToursFilter" icon slot="activator">
												<v-icon small>fa-filter</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.filter') }}</span>
										</v-tooltip>
										<v-tooltip bottom>
											<v-btn @click="excelClickBuyers" icon slot="activator">
												<v-icon small>fa-file-excel</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.excel') }}</span>
										</v-tooltip>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs12>
											<v-data-table
												:headers="toursHeadersBuyers"
												:items="buyerToursFiltered"
												:rows-per-page-items="[20, 30, 40]"
												class="elevation-0"
												must-sort
											>
												<template scope="props" slot="items">
													<tr v-if="props.item.id == null && toursFilterShown">
														<td>
															<InputField simple v-model="toursFiltersBuyers.id"/>
														</td>
														<td>
															<DatePicker :clearable="true" simple
																		v-model="toursFiltersBuyers.start_date"/>
														</td>
														<td>
															<InputField simple v-model="toursFiltersBuyers.name"/>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true"
																	  :data="'destinations'"
																	  simple
																	  v-model="toursFiltersBuyers.destination_id"/>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersBuyers.people.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersBuyers.people.max"></InputField>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersBuyers.total_trip_value.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersBuyers.total_trip_value.max"></InputField>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersBuyers.total_gross_profit.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersBuyers.total_gross_profit.max"></InputField>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersBuyers.price_per_person.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersBuyers.price_per_person.max"></InputField>
														</td>
														<td></td>
													</tr>
													<tr v-if="props.item.id != null">
														<td>{{ props.item.id }}</td>
														<td>{{ props.item.start_date_display }}</td>
														<td>{{ props.item.name }}</td>
														<td>{{ props.item.destination.name }}</td>
														<td>{{ props.item.guests_display }}</td>
														<td>{{ $formatMoney(props.item.total_trip_value) }} EUR</td>
														<td>{{ $formatMoney(props.item.total_gross_profit) }} EUR</td>
														<td>{{ $formatMoney(props.item.price) }} EUR</td>
														<td class="text-xs-right">
															<v-btn
																@click="openTour(props.item.id)"
																color="primary"
																flat icon slot="activator">
																<v-icon small>fa-external-link-alt</v-icon>
															</v-btn>
														</td>
													</tr>
												</template>
												<template #footer>
													<tr>
														<td colspan="5"></td>
														<td><b>{{ $formatMoney(totalTripValueSum) }} EUR</b></td>
														<td><b>{{ $formatMoney(totalGrossProfitSum) }} EUR</b></td>
														<td colspan="2"></td>
													</tr>
												</template>
											</v-data-table>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
				<v-tab-item v-if="company.id!=0 && company.subject_type_id==2">
					<v-layout row wrap>
						<v-flex xs12>
							<v-card>
								<v-card-text>
									<v-layout row wrap>
										<v-spacer></v-spacer>
										<v-tooltip bottom>
											<v-btn @click="toggleToursFilter" icon slot="activator">
												<v-icon small>fa-filter</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.filter') }}</span>
										</v-tooltip>
										<v-tooltip bottom>
											<v-btn @click="excelClickSuppliers" icon slot="activator">
												<v-icon small>fa-file-excel</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.excel') }}</span>
										</v-tooltip>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs12>
											<v-data-table
												:headers="toursHeadersSuppliers"
												:items="supplierToursFiltered"
												:rows-per-page-items="[20, 30, 40]"
												class="elevation-0"
												must-sort
											>
												<template scope="props" slot="items">
													<tr v-if="props.item.id == null && toursFilterShown">
														<td>
															<InputField simple v-model="toursFiltersSuppliers.id"/>
														</td>
														<td>
															<DatePicker :clearable="true" simple
																		v-model="toursFiltersSuppliers.start_date"/>
														</td>
														<td>
															<InputField simple v-model="toursFiltersSuppliers.name"/>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true"
																	  :data="'destinations'"
																	  simple
																	  v-model="toursFiltersSuppliers.destination_id"/>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersSuppliers.people.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersSuppliers.people.max"></InputField>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true"
																	  :data="'service-types'"
																	  simple
																	  v-model="toursFiltersSuppliers.service_type_id"/>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true"
																	  :data="'supplier-services'"
																	  simple
																	  v-model="toursFiltersSuppliers.supplier_service_id"/>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersSuppliers.cost.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersSuppliers.cost.max"></InputField>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersSuppliers.quantity.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersSuppliers.quantity.max"></InputField>
														</td>
														<td>
															<InputField :mask="'######'" :placeholder="$t('labels.min')"
																		simple
																		v-model="toursFiltersSuppliers.total_value.min"></InputField>
															<InputField :mask="'######'" :placeholder="$t('labels.max')"
																		simple
																		v-model="toursFiltersSuppliers.total_value.max"></InputField>
														</td>


														<td></td>
													</tr>
													<tr v-if="props.item.id != null">
														<td>{{ props.item.id }}</td>
														<td>{{ props.item.start_date_display }}</td>
														<td>{{ props.item.name }}</td>
														<td>{{ props.item.destination.name }}</td>
														<td>{{ props.item.guests_display }}</td>
														<td>{{ props.item.service_type }}</td>
														<td>{{ props.item.service_name }}</td>
														<td>{{ $formatMoney(props.item.service_cost) }} EUR</td>
														<td>{{ $formatMoney(props.item.service_quantity) }}</td>
														<td>{{ $formatMoney(props.item.service_total_value) }} EUR</td>
														<td class="text-xs-right">
															<v-btn
																@click="openTour(props.item.id)"
																color="primary"
																flat icon slot="activator">
																<v-icon small>fa-external-link-alt</v-icon>
															</v-btn>
														</td>
													</tr>
												</template>
												<template #footer>
													<td colspan="9"></td>
													<td><b>{{ $formatMoney(totalValueSum) }} EUR</b></td>
													<td></td>
												</template>
											</v-data-table>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
				<v-tab-item v-if="company.id!=0">
					<v-layout row wrap>
						<v-flex xs12>
							<v-card>
								<v-card-text>
									<v-layout row wrap>
										<v-tooltip bottom>
											<v-btn @click="addPerson" icon slot="activator">
												<v-icon small>fa-plus</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.addPerson') }}</span>
										</v-tooltip>
										<v-spacer></v-spacer>
										<v-tooltip bottom>
											<v-btn @click="togglePeopleFilter" icon slot="activator">
												<v-icon small>fa-filter</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.filter') }}</span>
										</v-tooltip>
										<v-tooltip bottom>
											<v-btn @click="excelClickPeople" icon slot="activator">
												<v-icon small>fa-file-excel</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.excel') }}</span>
										</v-tooltip>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs12>
											<v-data-table
												:headers="peopleHeaders"
												:items="peopleFiltered"
												:rows-per-page-items="[20, 30, 40]"
												class="elevation-0"
												must-sort
											>
												<template scope="props" slot="items">
													<tr v-if="props.item.id == null && peopleFilterShown">
														<td>
															<InputField simple v-model="peopleFilters.id"/>
														</td>
														<td>
															<InputField simple v-model="peopleFilters.first_name"/>
														</td>
														<td>
															<InputField simple v-model="peopleFilters.last_name"/>
														</td>
														<td>
															<InputField simple v-model="peopleFilters.email"/>
														</td>
													</tr>
													<tr v-if="props.item.id != null">
														<td>{{ props.item.id }}</td>
														<td>{{ props.item.first_name }}</td>
														<td>{{ props.item.last_name }}</td>
														<td>{{ props.item.email }}</td>
														<td class="text-xs-right">
															<v-btn
																@click="openPerson(props.item.id)"
																color="primary"
																flat icon slot="activator">
																<v-icon small>fa-external-link-alt</v-icon>
															</v-btn>
														</td>
													</tr>
												</template>
											</v-data-table>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
			</v-tabs>
		</v-layout>
	</v-container>
</template>

<script>
import PersonModal from "./modals/PersonModal";
import InputField from "./trinkets/InputField";
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import TextArea from "./trinkets/TextArea";
import UploadMultiple from "./trinkets/UploadMultiple";
import DatePicker from "./trinkets/DatePicker";
import CurrencyField from "./trinkets/CurrencyField";

export default {
	name: "Company",
	components: {UploadMultiple, CheckBox, InputField, Dropdown, TextArea, DatePicker, CurrencyField, PersonModal},
	props: {
		id: Number,
		action: String
	},
	data: function () {
		return {
			tabId: 0,
			initialLoad: false,
			company: {
				id: this.$route.params.id,
				name: '',
				address: '',
				city: '',
				country_id: null,
				phone: '',
				email: '',
				oib: '',
				subject_type_id: null,
				notes: '',
				documents: [],
				people: [],
				active: true,
				date_added: null,
				linked: false
			},
			companyValidation: {
				id: '',
				name: '',
				address: '',
				city: '',
				country_id: '',
				phone: '',
				email: '',
				oib: '',
				subject_type_id: '',
				notes: '',
				documents: '',
				active: '',
				date_added: ''
			},
			toursHeadersBuyers: [
				{text: this.$t('fields.id'), value: 'id'},
				{text: this.$t('fields.startDate'), value: 'start_date'},
				{text: this.$t('fields.tourName'), value: 'tour_name'},
				{text: this.$t('fields.tourDestination'), value: 'tour_destination'},
				{text: this.$t('fields.people'), value: 'guests_display'},
				{text: this.$t('fields.totalTripValue'), value: 'total_trip_value'},
				{text: this.$t('fields.totalGrossProfit'), value: 'total_gross_profit'},
				{text: this.$t('fields.pricePerPerson'), value: 'price_per_person'},
				{text: '', value: '', sortable: false}
			],
			toursHeadersSuppliers: [
				{text: this.$t('fields.id'), value: 'id'},
				{text: this.$t('fields.startDate'), value: 'start_date'},
				{text: this.$t('fields.tourName'), value: 'tour_name'},
				{text: this.$t('fields.tourDestination'), value: 'tour_destination'},
				{text: this.$t('fields.people'), value: 'guests_display'},
				{text: this.$t('fields.serviceType'), value: 'service_type'},
				{text: this.$t('fields.serviceName'), value: 'supplier_service_id'},
				{text: this.$t('fields.cost'), value: 'cost'},
				{text: this.$t('fields.quantity'), value: 'quantity'},
				{text: this.$t('fields.totalValue'), value: 'total_value'},
				{text: '', value: '', sortable: false}
			],
			peopleHeaders: [
				{text: this.$t('fields.id'), value: 'id'},
				{text: this.$t('fields.firstName'), value: 'first_name'},
				{text: this.$t('fields.lastName'), value: 'last_name'},
				{text: this.$t('fields.email'), value: 'email'},
				{text: '', value: '', sortable: false}
			],
			toursFiltersBuyers: {
				id: '',
				start_date: null,
				name: '',
				destination_id: null,
				people: {
					min: '',
					max: ''
				},
				total_trip_value: {
					min: '',
					max: ''
				},
				total_gross_profit: {
					min: '',
					max: ''
				},
				price_per_person: {
					min: '',
					max: ''
				}
			},
			toursFiltersSuppliers: {
				id: '',
				start_date: null,
				name: '',
				destination_id: null,
				people: {
					min: '',
					max: ''
				},
				service_type_id: null,
				supplier_service_id: null,
				cost: {
					min: '',
					max: ''
				},
				quantity: {
					min: '',
					max: ''
				},
				total_value: {
					min: '',
					max: ''
				}
			},
			peopleFilters: {
				id: '',
				first_name: '',
				last_name: '',
				email: ''
			},
			changesHappened: false,
			toursFilterShown: false,
			peopleFilterShown: false,
			personModalShow: false
		}
	},
	computed: {
		buyerToursFiltered() {
			let list = [{
				id: null
			}];
			for (let tour of this.company.tours) {
				let term = true;

				if (this.toursFiltersBuyers.id != '') {
					if (tour.id != this.toursFiltersBuyers.id) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.start_date != null) {
					if (tour.start_date != this.toursFiltersBuyers.start_date) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.name != '') {
					if (!tour.name.includes(this.toursFiltersBuyers.name)) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.destination_id != null) {
					if (tour.destination_id != this.toursFiltersBuyers.destination_id) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.people.min !== '') {
					if (tour.guests_display < this.toursFiltersBuyers.people.min) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.people.max !== '') {
					if (tour.guests_display > this.toursFiltersBuyers.people.max) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.total_trip_value.min !== '') {
					if (tour.total_trip_value < this.toursFiltersBuyers.total_trip_value.min) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.total_trip_value.max !== '') {
					if (tour.total_trip_value > this.toursFiltersBuyers.total_trip_value.max) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.total_gross_profit.min !== '') {
					if (tour.total_gross_profit < this.toursFiltersBuyers.total_gross_profit.min) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.total_gross_profit.max !== '') {
					if (tour.total_gross_profit > this.toursFiltersBuyers.total_gross_profit.max) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.price_per_person.min !== '') {
					if (tour.price < this.toursFiltersBuyers.price_per_person.min) {
						term = false;
					}
				}

				if (this.toursFiltersBuyers.price_per_person.max !== '') {
					if (tour.price > this.toursFiltersBuyers.price_per_person.max) {
						term = false;
					}
				}

				tour.tour_name = tour.name;
				tour.tour_destination = tour.destination.name;
				tour.price_per_person = tour.price;

				if (term) {
					list.push(tour);
				}
			}
			return list;
		},
		supplierToursFiltered() {
			let list = [{
				id: null
			}];
			for (let tour of this.company.tours) {
				let term = true;

				if (this.toursFiltersSuppliers.id != '') {
					if (tour.id != this.toursFiltersSuppliers.id) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.start_date != null) {
					if (tour.start_date != this.toursFiltersSuppliers.start_date) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.name != '') {
					if (!tour.name.includes(this.toursFiltersSuppliers.name)) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.service_type_id != null) {
					if (tour.service_type_id != this.toursFiltersSuppliers.service_type_id) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.supplier_service_id != null) {
					if (tour.supplier_service_id != this.toursFiltersSuppliers.supplier_service_id) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.destination_id != null) {
					if (tour.destination_id != this.toursFiltersSuppliers.destination_id) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.people.min !== '') {
					if (tour.guests_display < this.toursFiltersSuppliers.people.min) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.people.max !== '') {
					if (tour.guests_display > this.toursFiltersSuppliers.people.max) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.cost.min !== '') {
					if (tour.service_cost < this.toursFiltersSuppliers.cost.min) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.cost.max !== '') {
					if (tour.service_cost > this.toursFiltersSuppliers.cost.max) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.quantity.min !== '') {
					if (tour.service_quantity < this.toursFiltersSuppliers.quantity.min) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.quantity.max !== '') {
					if (tour.service_quantity > this.toursFiltersSuppliers.quantity.max) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.total_value.min !== '') {
					if (tour.service_total_value < this.toursFiltersSuppliers.total_value.min) {
						term = false;
					}
				}

				if (this.toursFiltersSuppliers.total_value.max !== '') {
					if (tour.service_total_value > this.toursFiltersSuppliers.total_value.max) {
						term = false;
					}
				}

				tour.tour_name = tour.name;
				tour.tour_destination = tour.destination.name;
				tour.supplier_service_id = tour.service_name;
				tour.cost = tour.service_cost;
				tour.quantity = tour.service_quantity;
				tour.total_value = tour.service_total_value;

				if (term) {
					list.push(tour);
				}
			}
			return list;
		},
		peopleFiltered() {
			let list = [{
				id: null
			}];
			for (let person of this.company.people) {
				let term = true;

				if (this.peopleFilters.id != '') {
					if (person.id != this.peopleFilters.id) {
						term = false;
					}
				}

				if (this.peopleFilters.first_name != '') {
					if (!person.first_name.includes(this.peopleFilters.first_name)) {
						term = false;
					}
				}

				if (this.peopleFilters.last_name != '') {
					if (!person.last_name.includes(this.peopleFilters.last_name)) {
						term = false;
					}
				}

				if (this.peopleFilters.email != '') {
					if (!person.email.includes(this.peopleFilters.email)) {
						term = false;
					}
				}

				if (term) {
					list.push(person);
				}
			}
			return list;
		},
		totalTripValueSum() {
			let sum = 0;
			for (let tour of this.buyerToursFiltered) {
				sum += tour.total_trip_value;
			}
			return sum;
		},
		totalGrossProfitSum() {
			let sum = 0;
			for (let tour of this.buyerToursFiltered) {
				sum += tour.total_gross_profit;
			}
			return sum;
		},
		totalValueSum() {
			let sum = 0;
			for (let tour of this.supplierToursFiltered) {
				sum += tour.service_total_value;
			}
			return sum;
		}
	},
	watch: {
		company: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
	},
	methods: {
		addPerson() {
			this.personModalShow = true;
		},
		personModalCallback() {
			this.personModalShow = false;
			let vm = this;
			this.$APICall('get', 'companies/' + this.company.id, {}, (data, success) => {
				if (success) {
					vm.company.people = data.people;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		togglePeopleFilter() {
			this.peopleFilterShown = !this.peopleFilterShown;
			if (!this.peopleFilterShown) {
				this.peopleFilters = {
					id: '',
					first_name: '',
					last_name: '',
					email: ''
				}
			}
		},
		excelClickPeople() {
			this.$APICall('post', 'excel/companies-people', this.peopleFiltered, (data, success) => {
				window.open(data.link);
			});
		},
		toggleToursFilter() {
			this.toursFilterShown = !this.toursFilterShown;
			if (!this.toursFilterShown) {
				this.toursFiltersBuyers = {
					id: '',
					start_date: null,
					name: '',
					destination_id: null,
					people: {
						min: '',
						max: ''
					},
					total_trip_value: {
						min: '',
						max: ''
					},
					total_gross_profit: {
						min: '',
						max: ''
					},
					price_per_person: {
						min: '',
						max: ''
					}
				};
				this.toursFiltersSuppliers = {
					id: '',
					start_date: null,
					name: '',
					destination_id: null,
					people: {
						min: '',
						max: ''
					},
					service_type_id: null,
					supplier_service_id: null,
					cost: {
						min: '',
						max: ''
					},
					quantity: {
						min: '',
						max: ''
					},
					total_value: {
						min: '',
						max: ''
					}
				};
			}
		},
		excelClickSuppliers() {
			this.$APICall('post', 'excel/companies-supplier-tours', this.supplierToursFiltered, (data, success) => {
				window.open(data.link);
			});
		},
		excelClickBuyers() {
			this.$APICall('post', 'excel/companies-buyer-tours', this.buyerToursFiltered, (data, success) => {
				window.open(data.link);
			});
		},
		openPerson(id) {
			let routeData = this.$router.resolve('/people/' + id);
			window.open(routeData.href, '_blank');
		},
		openTour(id) {
			let routeData = this.$router.resolve('/tours/' + id);
			window.open(routeData.href, '_blank');
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			let success = true;

			if (this.company.name == '') {
				success = false;
				this.companyValidation.name = this.$t('alerts.fieldError');
			} else {
				this.companyValidation.name = '';
			}
			if (this.company.address == '') {
				success = false;
				this.companyValidation.address = this.$t('alerts.fieldError');
			} else {
				this.companyValidation.address = '';
			}
			if (this.company.city == '') {
				success = false;
				this.companyValidation.city = this.$t('alerts.fieldError');
			} else {
				this.companyValidation.city = '';
			}
			if (this.company.country_id == null) {
				success = false;
				this.companyValidation.country_id = this.$t('alerts.fieldError');
			} else {
				this.companyValidation.country_id = '';
			}
			if (this.company.subject_type_id == null) {
				success = false;
				this.companyValidation.subject_type_id = this.$t('alerts.fieldError');
			} else {
				this.companyValidation.subject_type_id = '';
			}
			if ((this.company.oib != '') && (this.company.country_id == 53)) {
				if (!(this.$checkOIB(this.company.oib))) {
					success = false;
					this.companyValidation.oib = this.$t('alerts.oibError');
				} else {
					this.companyValidation.oib = '';
				}
			} else {
				this.companyValidation.oib = '';
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.company.id != 0) {
					action = 'put';
					addition = '/' + vm.company.id;
				}
				vm.$APICall(action, 'companies' + addition, vm.company, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.company.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		loadCompany() {
			let vm = this;
			this.$APICall('get', 'companies/' + this.company.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					usableData.subject_type_id = usableData.subject.subject_type_id;
					vm.company = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.companies'), href: '/#/companies', disabled: false},
						{text: vm.company.name, href: '/#/companies/' + vm.company.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Lists');
		if (this.company.id != 0) {
			this.loadCompany();
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.companies'), href: '/#/companies', disabled: false},
				{text: this.$t('modules.newCompany'), href: '/#/companies/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>
</style>
